import { State } from './trace.store';
import { ActionTree, Commit, Dispatch, MutationTree } from 'vuex';
import * as types from '../mutation-types';
import { Span, Trace } from './trace.d';

interface Node {
  apdex: number;
  avgResponseTime: number;
  cpm: number;
  id: string;
  isAlarm: boolean;
  name: string;
  numOfServer: number;
  numOfServerAlarm: number;
  numOfServiceAlarm: number;
  sla: number;
  type: string;
}

interface Option {
  key: string;
  label: string;
}

const mutations: MutationTree<State> = {
  [types.SET_SERVICES](state: State, data: Option[]): void {
    state.services = data;
  },
  [types.SET_ENDPOINTS](state: State, data: Option[]): void {
    state.endpoints = [{ key: 'ALL', label: 'All endpoints ' }].concat(data);
  },
  [types.SET_INSTANCES](state: State, data: Option[]): void {
    state.instances = [{ key: 'ALL', label: 'All instances' }].concat(data);
  },

  [types.SET_TRACE_FORM](state: State, data: any): void {
    if (data.queryOrder) {
      if (data.queryOrder === '') {
        data.queryOrder = 'BY_DURATION';
        localStorage.setItem('traceQueryOrder', 'BY_DURATION');
      } else {
        localStorage.setItem('traceQueryOrder', data.queryOrder);
      }
    }
    state.traceForm = data;
  },
  [types.SET_TRACE_FORM_ITEM](state: State, params: any): void {
    if (params.type && params.type  === 'queryOrder') {
      if (params.data === '') {
        params.data = localStorage.getItem('traceQueryOrder') ? localStorage.getItem('traceQueryOrder') : 'BY_DURATION';
      } 
        localStorage.setItem('traceQueryOrder', params.data);
    }
    state.traceForm[params.type] = params.data;
  },
  [types.SET_TRACELIST](state: State, data: Trace[]): void {
    state.traceList = data;
  },
  [types.SET_TRACELIST_TOTAL](state: State, data: number): void {
    state.traceTotal = data;
  },
  [types.SET_TRACE_SHOW_METHOD](state: State, data: boolean): void {
    state.showMethodTrace = data;
  },
  [types.SET_TRACE_SPANS](state: State, data: Span[]): void {
    state.traceSpans = data;
  },
  [types.SET_CURRENT_TRACE](state: State, data: Span): void {
    state.currentTrace = data;
  },
  [types.SET_REDIRECT_TRACE](state: State, data: any): void {
    state.redirectTrace = data;
  },
  [types.SET_DEFAULT_EMPTY_TRACE](state: State): void {
    state.currentTrace = {
      operationNames: [],
      duration: 0,
      isError: false,
      key: '',
      start: '',
      traceIds: []
    };
  },
  [types.SET_PDF_TRACE_SPANS](state: State, data: Span[]): void {
    state.pdfTraceSpans = data;
  },
  [types.SET_SELECTED_TRACE_LOADING](state: State, data: boolean): void {
    state.selectedTraceLoading = data;
  },
  [types.SET_TRACE_LOG_EXISTS](state: State, data: boolean): void {
    state.traceLogExists = data;
  },
  setCurrentTraceId(state: State, data: string) {
    state.currentTraceId = data;
  },
};

export default mutations;
